module.exports = __webpack_public_path__ + "img/powerpuff-girls-o-poder-da-amizade.9ced6e50.jpg";